<div>
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-1 tw-right-1 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon>close</mat-icon>
  </button>

  <form [formGroup]="formGroup" (submit)="submit()" class="tw-p-4">
    <div mat-dialog-title class="matp-dialog-title">
      <span class="absolute h-14 w-14 top-0 start-0"
        >設定テンプレート{{ updating ? "編集" : "新規登録" }}</span
      >
    </div>

    <mat-dialog-content class="tw-w-full !tw-pt-6 !tw-mb-16">
      <div
        class="tw-my-2 tw-flex tw-justify-start tw-items-center tw-ml-8 tw-min-h-[45px]"
      >
        <div class="tw-flex tw-items-center matp-form-field-slim">
          <mat-form-field
            class="tw-w-80 tw-flex tw-justify-end tw-mr-2 matp-form-field-slim"
            appearance="outline"
            floatLabel="always"
          >
            <mat-label>設定テンプレート名</mat-label>
            <input
              matInput
              formControlName="assetTypeName"
              name="assetTypeName"
            />
            @if (formGroup.controls["assetTypeName"].errors?.["required"]) {
              <mat-error> 設定テンプレート名を入力してください。 </mat-error>
            } @else if (
              formGroup.controls["assetTypeName"].errors?.["maxlength"]
            ) {
              <mat-error>128文字以下で入力してください。</mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="tw-ml-8">
        <div
          class="tw-flex tw-justify-start tw-items-center tw-min-h-[45px] tw-my-4"
        >
          <div class="tw-flex tw-items-center matp-form-field-slim">
            <mat-form-field
              appearance="outline"
              floatLabel="always"
              class="tw-w-80"
            >
              <mat-label>デバイス種類</mat-label>
              <mat-select formControlName="deviceTypeId">
                @for (
                  deviceType of deviceTypeList;
                  track deviceType.deviceTypeKey
                ) {
                  <mat-option
                    [value]="deviceType.deviceTypeKey"
                    (click)="selectDeviceType(deviceType.deviceTypeKey)"
                  >
                    {{ deviceType.displayName }}
                  </mat-option>
                }
              </mat-select>
              <!-- <mat-error
                *ngIf="formGroup.controls.deviceTypeId.errors?.['required']"
              >
                デバイス種類を選択してください。
              </mat-error> -->
            </mat-form-field>
          </div>
        </div>

        <!-- データ収集期間 -->
        <div
          class="tw-flex tw-gap-8 matp-form-field-slim tw-my-4"
          *ngIf="formGroup.controls['deviceTypeId'].value"
        >
          <mat-form-field
            class="tw-w-36"
            appearance="outline"
            floatLabel="always"
          >
            <mat-label>測定間隔</mat-label>
            <mat-select
              formControlName="samplingFrequency"
              id="sampling-frequency"
              name="samplingFrequency"
              (selectionChange)="reportingFrequencyValueChanged()"
            >
              <mat-option
                *ngFor="let frequency of samplingFrequencies"
                [value]="frequency"
              >
                {{ frequency | minutesLabel }}
              </mat-option>
            </mat-select>
            @if (
              formGroup.get("samplingFrequency")!.hasError("invalidSelection")
            ) {
              <mat-error> 測定間隔を選択してください </mat-error>
            } @else if (
              formGroup.get("samplingFrequency")!.hasError("required")
            ) {
              <mat-error>測定間隔を選択してください</mat-error>
            }
          </mat-form-field>

          <mat-form-field
            class="tw-w-36"
            appearance="outline"
            floatLabel="always"
          >
            <mat-label>送信間隔</mat-label>
            <mat-select
              formControlName="reportingFrequency"
              id="reporting-frequency"
              name="reportingFrequency"
              required
            >
              <mat-option
                *ngFor="let frequency of reportingFrequencies"
                [value]="frequency"
                [disabled]="getDisabledReportingFrequency(frequency)"
              >
                {{ frequency | minutesLabel }}
              </mat-option>
            </mat-select>
            @if (
              formGroup.get("reportingFrequency")!.hasError("invalidSelection")
            ) {
              <mat-error>
                測定間隔以上、かつ倍数の値を指定してください
              </mat-error>
            } @else if (
              formGroup.get("reportingFrequency")!.hasError("required")
            ) {
              <mat-error>送信間隔を選択してください</mat-error>
            }
          </mat-form-field>
        </div>

        <div
          class="tw-col-span-1 tw-flex tw-flex-row tw-gap-4 tw-my-4"
          *ngIf="formGroup.controls['deviceTypeId'].value"
        >
          <div class="tw-gap-y-4">
            <div
              *ngIf="deviceType?.locationSensor !== false"
              class="tw-flex tw-items-center"
            >
              <p class="tw-w-52 tw-my-4">位置検知</p>
              <mat-slide-toggle
                color="primary"
                class="tw-min-w-[46px]"
                formControlName="locationDetected"
              >
              </mat-slide-toggle>
              <div
                class="tw-flex tw-items-center tw-gap-3 tw-ml-16"
                formGroupName="locationPriority"
              >
                <mat-form-field
                  appearance="outline"
                  floatLabel="always"
                  class="tw-h-10 matp-form-field-slim tw-w-52"
                  *ngIf="locationPrioritiesNum >= 1"
                >
                  <mat-label>位置測位技術優先度 1</mat-label>
                  <mat-select
                    formControlName="locationPriority1"
                    id="location-priority-1"
                    name="locationPriority1"
                  >
                    <mat-option [value]="null"></mat-option>
                    <mat-option
                      *ngFor="let item of locationPriorities | keyvalue"
                      [value]="item.value"
                      [disabled]="
                        getLocationPriorityDisabled(
                          item.value,
                          formGroup.get('locationPriority.locationPriority2')!
                            .value,
                          formGroup.get('locationPriority.locationPriority3')!
                            .value
                        )
                      "
                    >
                      {{ item.key }}
                    </mat-option>
                  </mat-select>
                  @if (
                    formGroup
                      .get("locationPriority")
                      ?.get("locationPriority1")!
                      .hasError("invalidValue")
                  ) {
                    <mat-error> GNSSは選択できません。 </mat-error>
                  } @else if (
                    formGroup
                      .get("locationPriority")
                      ?.get("locationPriority1")!
                      .hasError("invalidSelection")
                  ) {
                    <mat-error>
                      位置測位技術優先度1を選択してください。
                    </mat-error>
                  } @else if (
                    formGroup
                      .get("locationPriority")
                      ?.get("locationPriority1")!
                      .hasError("required")
                  ) {
                    <mat-error>
                      位置測位技術優先度を選択してください。
                    </mat-error>
                  }
                </mat-form-field>
                <mat-form-field
                  appearance="outline"
                  floatLabel="always"
                  class="tw-h-10 matp-form-field-slim tw-w-52"
                  *ngIf="locationPrioritiesNum >= 2"
                >
                  <mat-label>位置測位技術優先度 2</mat-label>
                  <mat-select
                    formControlName="locationPriority2"
                    id="location-priority-2"
                    name="locationPriority2"
                  >
                    <mat-option [value]="null"></mat-option>
                    <mat-option
                      *ngFor="let item of locationPriorities | keyvalue"
                      [value]="item.value"
                      [disabled]="
                        getLocationPriorityDisabled(
                          item.value,
                          formGroup.get('locationPriority.locationPriority1')!
                            .value,
                          formGroup.get('locationPriority.locationPriority3')!
                            .value
                        )
                      "
                    >
                      {{ item.key }}
                    </mat-option>
                  </mat-select>
                  @if (
                    formGroup
                      .get("locationPriority")
                      ?.get("locationPriority2")!
                      .hasError("invalidValue")
                  ) {
                    <mat-error> GNSSは選択できません。 </mat-error>
                  } @else if (
                    formGroup
                      .get("locationPriority")
                      ?.get("locationPriority2")!
                      .hasError("invalidSelection")
                  ) {
                    <mat-error>
                      位置測位技術優先度2を選択してください。
                    </mat-error>
                  } @else if (
                    formGroup
                      .get("locationPriority")
                      ?.get("locationPriority2")!
                      .hasError("required")
                  ) {
                    <mat-error>
                      位置測位技術優先度を選択してください。
                    </mat-error>
                  }
                </mat-form-field>
                <mat-form-field
                  appearance="outline"
                  floatLabel="always"
                  class="tw-h-10 matp-form-field-slim tw-w-52"
                  *ngIf="locationPrioritiesNum >= 3"
                >
                  <mat-label>位置測位技術優先度 3</mat-label>
                  <mat-select
                    formControlName="locationPriority3"
                    id="location-priority-3"
                    name="locationPriority3"
                  >
                    <mat-option [value]="null"></mat-option>
                    <mat-option
                      *ngFor="let item of locationPriorities | keyvalue"
                      [value]="item.value"
                      [disabled]="
                        getLocationPriorityDisabled(
                          item.value,
                          formGroup.get('locationPriority.locationPriority1')!
                            .value,
                          formGroup.get('locationPriority.locationPriority2')!
                            .value
                        )
                      "
                      >{{ item.key }}
                    </mat-option>
                  </mat-select>
                  @if (
                    formGroup
                      .get("locationPriority")
                      ?.get("locationPriority3")!
                      .hasError("invalidValue")
                  ) {
                    <mat-error> GNSSは選択できません。 </mat-error>
                  } @else if (
                    formGroup
                      .get("locationPriority")
                      ?.get("locationPriority3")!
                      .hasError("invalidSelection")
                  ) {
                    <mat-error>
                      位置測位技術優先度3を選択してください。
                    </mat-error>
                  } @else if (
                    formGroup
                      .get("locationPriority")
                      ?.get("locationPriority3")!
                      .hasError("required")
                  ) {
                    <mat-error>
                      位置測位技術優先度を選択してください。
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="tw-mt-2 tw-ml-8">
        @if (
          deviceType?.temperatureSensor === true ||
          deviceType?.pressureSensor === true ||
          deviceType?.humiditySensor === true ||
          deviceType?.lightSensor === true ||
          deviceType?.tiltSensor === true
        ) {
          <div class="tw-min-w-[300px] tw-ml-36 tw-flex tw-items-center">
            センサーON/OFF
          </div>
          <div class="tw-flex tw-items-center tw-gap-3">
            <!-- ヘッダー -->
            <div class="tw-flex-none tw-w-52 tw-ml-80">アラート上限</div>
            <div class="tw-flex-none tw-w-52">ワーニング上限</div>
            <div class="tw-flex-none tw-w-52">ワーニング下限</div>
            <div class="tw-flex-none tw-w-52">アラート下限</div>
          </div>

          <!-- 温度センサー -->
          <div
            class="tw-min-h-[45px] tw-w-full tw-flex tw-items-center tw-my-2"
            *ngIf="deviceType?.temperatureSensor !== false"
          >
            <p class="tw-min-w-[205px] tw-my-4">温度センサー</p>
            <mat-slide-toggle
              color="primary"
              class="tw-min-w-[46px]"
              formControlName="temperature"
            >
            </mat-slide-toggle>
            <div
              formGroupName="temperatureSettings"
              class="tw-flex tw-gap-3 tw-h-11"
            >
              <div class="tw-ml-16 matp-form-field-slim">
                <mat-form-field appearance="outline" class="tw-w-52">
                  <input matInput formControlName="temperatureAlertMax" />
                  <span
                    matTextSuffix
                    [ngClass]="{
                      'tw-text-gray-400': !formGroup.get('temperature')?.value,
                    }"
                    >&deg;C</span
                  >
                  @if (
                    formGroup
                      .get("temperatureSettings")
                      ?.get("temperatureAlertMax")!
                      .hasError("overMax")
                  ) {
                    <mat-error> 60以下を指定してください </mat-error>
                  } @else if (
                    formGroup
                      .get("temperatureSettings")
                      ?.get("temperatureAlertMax")!
                      .hasError("required") ||
                    formGroup
                      .get("temperatureSettings")
                      ?.get("temperatureAlertMax")!
                      .hasError("invalidFormat")
                  ) {
                    <mat-error>整数を入力してください。</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="matp-form-field-slim">
                <mat-form-field appearance="outline" class="tw-w-52">
                  <input matInput formControlName="temperaturePrealertMax" />
                  <span
                    matTextSuffix
                    [ngClass]="{
                      'tw-text-gray-400': !formGroup.get('temperature')?.value,
                    }"
                    >&deg;C</span
                  >
                  @if (
                    formGroup
                      .get("temperatureSettings")
                      ?.get("temperaturePrealertMax")!
                      .hasError("overMax")
                  ) {
                    <mat-error
                      >{{
                        formGroup.get("temperatureSettings.temperatureAlertMax")
                          ?.value
                      }}以下を入力してください。</mat-error
                    >
                  } @else if (
                    formGroup
                      .get("temperatureSettings")
                      ?.get("temperaturePrealertMax")!
                      .hasError("underMin")
                  ) {
                    <mat-error
                      >{{
                        formGroup.get(
                          "temperatureSettings.temperaturePrealertMin"
                        )?.value
                      }}以上を入力してください。</mat-error
                    >
                  } @else if (
                    formGroup
                      .get("temperatureSettings")
                      ?.get("temperaturePrealertMax")!
                      .hasError("required") ||
                    formGroup
                      .get("temperatureSettings")
                      ?.get("temperaturePrealertMax")!
                      .hasError("invalidFormat")
                  ) {
                    <mat-error>整数を入力してください。</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="matp-form-field-slim">
                <mat-form-field appearance="outline" class="tw-w-52">
                  <input matInput formControlName="temperaturePrealertMin" />
                  <span
                    matTextSuffix
                    [ngClass]="{
                      'tw-text-gray-400': !formGroup.get('temperature')?.value,
                    }"
                    >&deg;C</span
                  >
                  @if (
                    formGroup
                      .get("temperatureSettings")
                      ?.get("temperaturePrealertMin")!
                      .hasError("underMin")
                  ) {
                    <mat-error
                      >{{
                        formGroup.get("temperatureSettings.temperatureAlertMin")
                          ?.value
                      }}以上を入力してください。</mat-error
                    >
                  } @else if (
                    formGroup
                      .get("temperatureSettings")
                      ?.get("temperaturePrealertMin")!
                      .hasError("required") ||
                    formGroup
                      .get("temperatureSettings")
                      ?.get("temperaturePrealertMin")!
                      .hasError("invalidFormat")
                  ) {
                    <mat-error>整数を入力してください。</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="matp-form-field-slim">
                <mat-form-field appearance="outline" class="tw-w-52">
                  <input matInput formControlName="temperatureAlertMin" />
                  <span
                    matTextSuffix
                    [ngClass]="{
                      'tw-text-gray-400': !formGroup.get('temperature')?.value,
                    }"
                    >&deg;C</span
                  >
                  @if (
                    formGroup
                      .get("temperatureSettings")
                      ?.get("temperatureAlertMin")!
                      .hasError("underMin")
                  ) {
                    <mat-error> -20以上を指定してください </mat-error>
                  } @else if (
                    formGroup
                      .get("temperatureSettings")
                      ?.get("temperatureAlertMin")!
                      .hasError("required") ||
                    formGroup
                      .get("temperatureSettings")
                      ?.get("temperatureAlertMin")!
                      .hasError("invalidFormat")
                  ) {
                    <mat-error>整数を入力してください。</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>

          <!-- 気圧センサー -->
          <div
            class="tw-min-h-[45px] tw-w-full tw-flex tw-items-center tw-my-2"
            *ngIf="deviceType?.pressureSensor !== false"
          >
            <p class="tw-min-w-[205px] tw-my-4">気圧センサー</p>
            <mat-slide-toggle
              color="primary"
              class="tw-min-w-[46px]"
              formControlName="pressure"
            >
            </mat-slide-toggle>
            <div
              formGroupName="pressureSettings"
              class="tw-flex tw-gap-3 tw-h-11"
            >
              <div class="tw-ml-16 matp-form-field-slim">
                <mat-form-field appearance="outline" class="tw-w-52">
                  <input matInput formControlName="pressureAlertMax" />
                  <span
                    matTextSuffix
                    [ngClass]="{
                      'tw-text-gray-400': !formGroup.get('pressure')?.value,
                    }"
                    >hPa</span
                  >
                  @if (
                    formGroup
                      .get("pressureSettings")
                      ?.get("pressureAlertMax")!
                      .hasError("overMax")
                  ) {
                    <mat-error> 1260以下を指定してください </mat-error>
                  } @else if (
                    formGroup
                      .get("pressureSettings")
                      ?.get("pressureAlertMax")!
                      .hasError("required") ||
                    formGroup
                      .get("pressureSettings")
                      ?.get("pressureAlertMax")!
                      .hasError("invalidFormat")
                  ) {
                    <mat-error>整数を入力してください。</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="matp-form-field-slim">
                <mat-form-field appearance="outline" class="tw-w-52">
                  <input matInput formControlName="pressurePrealertMax" />
                  <span
                    matTextSuffix
                    [ngClass]="{
                      'tw-text-gray-400': !formGroup.get('pressure')?.value,
                    }"
                    >hPa</span
                  >
                  @if (
                    formGroup
                      .get("pressureSettings")
                      ?.get("pressurePrealertMax")!
                      .hasError("overMax")
                  ) {
                    <mat-error
                      >{{
                        formGroup.get("pressureSettings.pressureAlertMax")
                          ?.value
                      }}以下を入力してください。</mat-error
                    >
                  } @else if (
                    formGroup
                      .get("pressureSettings")
                      ?.get("pressurePrealertMax")!
                      .hasError("underMin")
                  ) {
                    <mat-error
                      >{{
                        formGroup.get("pressureSettings.pressurePrealertMin")
                          ?.value
                      }}以上を入力してください。</mat-error
                    >
                  } @else if (
                    formGroup
                      .get("pressureSettings")
                      ?.get("pressurePrealertMax")!
                      .hasError("required") ||
                    formGroup
                      .get("pressureSettings")
                      ?.get("pressurePrealertMax")!
                      .hasError("invalidFormat")
                  ) {
                    <mat-error>整数を入力してください。</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="matp-form-field-slim">
                <mat-form-field appearance="outline" class="tw-w-52">
                  <input matInput formControlName="pressurePrealertMin" />
                  <span
                    matTextSuffix
                    [ngClass]="{
                      'tw-text-gray-400': !formGroup.get('pressure')?.value,
                    }"
                    >hPa</span
                  >
                  @if (
                    formGroup
                      .get("pressureSettings")
                      ?.get("pressurePrealertMin")!
                      .hasError("underMin")
                  ) {
                    <mat-error
                      >{{
                        formGroup.get("pressureSettings.pressureAlertMin")
                          ?.value
                      }}以上を入力してください。</mat-error
                    >
                  } @else if (
                    formGroup
                      .get("pressureSettings")
                      ?.get("pressurePrealertMin")!
                      .hasError("required") ||
                    formGroup
                      .get("pressureSettings")
                      ?.get("pressurePrealertMin")!
                      .hasError("invalidFormat")
                  ) {
                    <mat-error>整数を入力してください。</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="matp-form-field-slim">
                <mat-form-field appearance="outline" class="tw-w-52">
                  <input matInput formControlName="pressureAlertMin" />
                  <span
                    matTextSuffix
                    [ngClass]="{
                      'tw-text-gray-400': !formGroup.get('pressure')?.value,
                    }"
                    >hPa</span
                  >
                  @if (
                    formGroup
                      .get("pressureSettings")
                      ?.get("pressureAlertMin")!
                      .hasError("underMin")
                  ) {
                    <mat-error> 260以上を指定してください </mat-error>
                  } @else if (
                    formGroup
                      .get("pressureSettings")
                      ?.get("pressureAlertMin")!
                      .hasError("required") ||
                    formGroup
                      .get("pressureSettings")
                      ?.get("pressureAlertMin")!
                      .hasError("invalidFormat")
                  ) {
                    <mat-error>整数を入力してください。</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>

          <!-- 湿度センサー -->
          <div
            class="tw-min-h-[45px] tw-w-full tw-flex tw-items-center tw-my-2"
            *ngIf="deviceType?.humiditySensor !== false"
          >
            <p class="tw-min-w-[205px] tw-my-4">湿度センサー</p>
            <mat-slide-toggle
              color="primary"
              class="tw-min-w-[46px]"
              formControlName="humidity"
            >
            </mat-slide-toggle>
            <div
              formGroupName="humiditySettings"
              class="tw-flex tw-gap-3 tw-h-11"
            >
              <div class="tw-ml-16 matp-form-field-slim">
                <mat-form-field appearance="outline" class="tw-w-52">
                  <input matInput formControlName="humidityAlertMax" />
                  <span
                    matTextSuffix
                    [ngClass]="{
                      'tw-text-gray-400': !formGroup.get('humidity')?.value,
                    }"
                    >%RH</span
                  >
                  @if (
                    formGroup
                      .get("humiditySettings")
                      ?.get("humidityAlertMax")!
                      .hasError("overMax")
                  ) {
                    <mat-error> 100以下を指定してください </mat-error>
                  } @else if (
                    formGroup
                      .get("humiditySettings")
                      ?.get("humidityAlertMax")!
                      .hasError("required") ||
                    formGroup
                      .get("humiditySettings")
                      ?.get("humidityAlertMax")!
                      .hasError("invalidFormat")
                  ) {
                    <mat-error>整数を入力してください。</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="matp-form-field-slim">
                <mat-form-field appearance="outline" class="tw-w-52">
                  <input matInput formControlName="humidityPrealertMax" />
                  <span
                    matTextSuffix
                    [ngClass]="{
                      'tw-text-gray-400': !formGroup.get('humidity')?.value,
                    }"
                    >%RH</span
                  >
                  @if (
                    formGroup
                      .get("humiditySettings")
                      ?.get("humidityPrealertMax")!
                      .hasError("overMax")
                  ) {
                    <mat-error
                      >{{
                        formGroup.get("humiditySettings.humidityAlertMax")
                          ?.value
                      }}以下を入力してください。</mat-error
                    >
                  } @else if (
                    formGroup
                      .get("humiditySettings")
                      ?.get("humidityPrealertMax")!
                      .hasError("underMin")
                  ) {
                    <mat-error
                      >{{
                        formGroup.get("humiditySettings.humidityPrealertMin")
                          ?.value
                      }}以上を入力してください。</mat-error
                    >
                  } @else if (
                    formGroup
                      .get("humiditySettings")
                      ?.get("humidityPrealertMax")!
                      .hasError("required") ||
                    formGroup
                      .get("humiditySettings")
                      ?.get("humidityPrealertMax")!
                      .hasError("invalidFormat")
                  ) {
                    <mat-error>整数を入力してください。</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="matp-form-field-slim">
                <mat-form-field appearance="outline" class="tw-w-52">
                  <input matInput formControlName="humidityPrealertMin" />
                  <span
                    matTextSuffix
                    [ngClass]="{
                      'tw-text-gray-400': !formGroup.get('humidity')?.value,
                    }"
                    >%RH</span
                  >
                  @if (
                    formGroup
                      .get("humiditySettings")
                      ?.get("humidityPrealertMin")!
                      .hasError("underMin")
                  ) {
                    <mat-error
                      >{{
                        formGroup.get("humiditySettings.humidityAlertMin")
                          ?.value
                      }}以上を入力してください。</mat-error
                    >
                  } @else if (
                    formGroup
                      .get("humiditySettings")
                      ?.get("humidityPrealertMin")!
                      .hasError("required") ||
                    formGroup
                      .get("humiditySettings")
                      ?.get("humidityPrealertMin")!
                      .hasError("invalidFormat")
                  ) {
                    <mat-error>整数を入力してください。</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="matp-form-field-slim">
                <mat-form-field appearance="outline" class="tw-w-52">
                  <input matInput formControlName="humidityAlertMin" />
                  <span
                    matTextSuffix
                    [ngClass]="{
                      'tw-text-gray-400': !formGroup.get('humidity')?.value,
                    }"
                    >%RH</span
                  >
                  @if (
                    formGroup
                      .get("humiditySettings")
                      ?.get("humidityAlertMin")!
                      .hasError("underMin")
                  ) {
                    <mat-error> 0以上を指定してください </mat-error>
                  } @else if (
                    formGroup
                      .get("humiditySettings")
                      ?.get("humidityAlertMin")!
                      .hasError("required") ||
                    formGroup
                      .get("humiditySettings")
                      ?.get("humidityAlertMin")!
                      .hasError("invalidFormat")
                  ) {
                    <mat-error>整数を入力してください。</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>

          <!-- 照度センサー -->
          <div
            class="tw-min-h-[45px] tw-w-full tw-flex tw-items-center tw-my-2"
            *ngIf="deviceType?.lightSensor !== false"
          >
            <p class="tw-min-w-[205px] tw-my-4">照度センサー</p>
            <mat-slide-toggle
              color="primary"
              class="tw-min-w-[46px]"
              formControlName="light"
            >
            </mat-slide-toggle>
            <div formGroupName="lightSettings" class="tw-flex tw-gap-3 tw-h-11">
              <div class="tw-ml-16 matp-form-field-slim">
                <mat-form-field appearance="outline" class="tw-w-52">
                  <input matInput formControlName="lightAlertMax" />
                  <span
                    matTextSuffix
                    [ngClass]="{
                      'tw-text-gray-400': !formGroup.get('light')?.value,
                    }"
                    >Lux</span
                  >
                  @if (
                    formGroup
                      .get("lightSettings")
                      ?.get("lightAlertMax")!
                      .hasError("overMax")
                  ) {
                    <mat-error> 66000以下を指定してください </mat-error>
                  } @else if (
                    formGroup
                      .get("lightSettings")
                      ?.get("lightAlertMax")!
                      .hasError("required") ||
                    formGroup
                      .get("lightSettings")
                      ?.get("lightAlertMax")!
                      .hasError("invalidFormat")
                  ) {
                    <mat-error>整数を入力してください。</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="matp-form-field-slim">
                <mat-form-field appearance="outline" class="tw-w-52">
                  <input matInput formControlName="lightPrealertMax" />
                  <span
                    matTextSuffix
                    [ngClass]="{
                      'tw-text-gray-400': !formGroup.get('light')?.value,
                    }"
                    >Lux</span
                  >
                  @if (
                    formGroup
                      .get("lightSettings")
                      ?.get("lightPrealertMax")!
                      .hasError("overMax")
                  ) {
                    <mat-error
                      >{{
                        formGroup.get("lightSettings.lightAlertMax")?.value
                      }}以下を入力してください。</mat-error
                    >
                  } @else if (
                    formGroup
                      .get("lightSettings")
                      ?.get("lightPrealertMax")!
                      .hasError("underMin")
                  ) {
                    <mat-error
                      >{{
                        formGroup.get("lightSettings.lightPrealertMin")?.value
                      }}以上を入力してください。</mat-error
                    >
                  } @else if (
                    formGroup
                      .get("lightSettings")
                      ?.get("lightPrealertMax")!
                      .hasError("required") ||
                    formGroup
                      .get("lightSettings")
                      ?.get("lightPrealertMax")!
                      .hasError("invalidFormat")
                  ) {
                    <mat-error>整数を入力してください。</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="matp-form-field-slim">
                <mat-form-field appearance="outline" class="tw-w-52">
                  <input matInput formControlName="lightPrealertMin" />
                  <span
                    matTextSuffix
                    [ngClass]="{
                      'tw-text-gray-400': !formGroup.get('light')?.value,
                    }"
                    >Lux</span
                  >
                  @if (
                    formGroup
                      .get("lightSettings")
                      ?.get("lightPrealertMin")!
                      .hasError("underMin")
                  ) {
                    <mat-error
                      >{{
                        formGroup.get("lightSettings.lightAlertMin")?.value
                      }}以上を入力してください。</mat-error
                    >
                  } @else if (
                    formGroup
                      .get("lightSettings")
                      ?.get("lightPrealertMin")!
                      .hasError("required") ||
                    formGroup
                      .get("lightSettings")
                      ?.get("lightPrealertMin")!
                      .hasError("invalidFormat")
                  ) {
                    <mat-error>整数を入力してください。</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="matp-form-field-slim">
                <mat-form-field appearance="outline" class="tw-w-52">
                  <input matInput formControlName="lightAlertMin" />
                  <span
                    matTextSuffix
                    [ngClass]="{
                      'tw-text-gray-400': !formGroup.get('light')?.value,
                    }"
                    >Lux</span
                  >
                  @if (
                    formGroup
                      .get("lightSettings")
                      ?.get("lightAlertMin")!
                      .hasError("underMin")
                  ) {
                    <mat-error> -1以上を指定してください </mat-error>
                  } @else if (
                    formGroup
                      .get("lightSettings")
                      ?.get("lightAlertMin")!
                      .hasError("required") ||
                    formGroup
                      .get("lightSettings")
                      ?.get("lightAlertMin")!
                      .hasError("invalidFormat")
                  ) {
                    <mat-error>整数を入力してください。</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>

          <!-- 傾斜センサー -->
          <div
            class="tw-min-h-[45px] tw-w-full tw-flex tw-items-center tw-my-2"
            *ngIf="deviceType?.tiltSensor !== false"
          >
            <p class="tw-min-w-[205px] tw-my-4">傾斜センサー</p>
            <mat-slide-toggle
              color="primary"
              class="tw-min-w-[46px]"
              formControlName="tilt"
            >
            </mat-slide-toggle>
            <div formGroupName="tiltSettings" class="tw-flex tw-gap-3 tw-h-11">
              <div class="tw-ml-16 matp-form-field-slim">
                <mat-form-field appearance="outline" class="tw-w-52">
                  <input matInput formControlName="tiltAlertMax" />
                  <span
                    matTextSuffix
                    [ngClass]="{
                      'tw-text-gray-400': !formGroup.get('tilt')?.value,
                    }"
                    >度</span
                  >
                  @if (
                    formGroup
                      .get("tiltSettings")
                      ?.get("tiltAlertMax")!
                      .hasError("overMax")
                  ) {
                    <mat-error> 180以下を指定してください </mat-error>
                  } @else if (
                    formGroup
                      .get("tiltSettings")
                      ?.get("tiltAlertMax")!
                      .hasError("underMin")
                  ) {
                    <mat-error>0以上を指定してください。</mat-error>
                  } @else if (
                    formGroup
                      .get("tiltSettings")
                      ?.get("tiltAlertMax")!
                      .hasError("required") ||
                    formGroup
                      .get("tiltSettings")
                      ?.get("tiltAlertMax")!
                      .hasError("invalidFormat")
                  ) {
                    <mat-error>整数を入力してください。</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>
        }
      </div>

      <div class="tw-mt-2 tw-ml-8">
        @if (
          deviceType?.fallDetected === true ||
          deviceType?.mcdDetected === true ||
          deviceType?.lightExposureDetected === true ||
          deviceType?.shockDetected === true
        ) {
          <div class="tw-ml-36">イベント検知 ON/OFF</div>
          <div>
            <div
              class="tw-min-h-[45px] tw-w-full tw-flex tw-items-center tw-my-2"
              *ngIf="deviceType?.fallDetected !== false"
            >
              <p class="tw-w-52 tw-my-4">落下検知</p>
              <mat-slide-toggle
                color="primary"
                class="tw-min-w-[46px]"
                formControlName="fallDetected"
              >
              </mat-slide-toggle>
            </div>
            <div
              class="tw-min-h-[45px] tw-w-full tw-flex tw-items-center tw-my-2"
              *ngIf="deviceType?.mcdDetected !== false"
            >
              <p class="tw-w-52 tw-my-4">動作検知</p>
              <mat-slide-toggle color="primary" formControlName="mcdDetected">
              </mat-slide-toggle>
            </div>
            <div
              class="tw-min-h-[45px] tw-w-full tw-flex tw-items-center tw-my-2"
              *ngIf="deviceType?.lightExposureDetected !== false"
            >
              <p class="tw-w-52 tw-my-4">明暗検知</p>
              <mat-slide-toggle
                color="primary"
                class="tw-min-w-[46px]"
                formControlName="lightExposureDetected"
              >
              </mat-slide-toggle>
              <mat-form-field
                appearance="outline"
                class="tw-ml-16 matp-form-field-slim tw-w-52 tw-h-11"
              >
                <mat-select
                  formControlName="lightExposureDetectValue"
                  id="light-exposure-detect-value"
                  name="lightExposureDetectValue"
                >
                  <!-- TODO 動作確認課題No.527よりOne-timeは選択できないようにする -->
                  <!-- <mat-option
                    *ngFor="let item of lightExposureDetectValues | keyvalue"
                    [value]="item.value"
                  >
                    {{ item.key }}
                  </mat-option> -->
                  <mat-option value="continuous"> Continuous </mat-option>
                  <mat-option value="onetime" disabled> One-time </mat-option>
                </mat-select>
                @if (
                  formGroup
                    .get("lightExposureDetectValue")!
                    .hasError("invalidSelection") ||
                  formGroup
                    .get("lightExposureDetectValue")!
                    .hasError("required")
                ) {
                  <mat-error> 設定値を選択してください。 </mat-error>
                }
              </mat-form-field>
            </div>
            @if (deviceType?.lightExposureDetected) {
              <div class="tw-w-full tw-flex tw-items-center tw-mt-4">
                <span class="tw-w-52"></span>
                @if (
                  formGroup.controls["lightExposureDetected"].errors?.[
                    "requiredLight"
                  ]
                ) {
                  <mat-error> 照度センサーをONにしてください。 </mat-error>
                }
              </div>
            }
            <div
              class="tw-min-h-[45px] tw-w-full tw-flex tw-items-center tw-my-2"
              *ngIf="deviceType?.shockDetected !== false"
            >
              <p class="tw-w-52 tw-my-4">衝撃検知</p>
              <mat-slide-toggle
                color="primary"
                class="tw-min-w-[46px]"
                formControlName="shockDetected"
              >
              </mat-slide-toggle>
              <mat-form-field
                appearance="outline"
                class="tw-ml-16 matp-form-field-slim tw-w-52 tw-h-11"
              >
                <mat-select
                  formControlName="shockDetectedDetectValue"
                  id="shock-detected-detect-value"
                  name="shockDetectedDetectValue"
                >
                  <mat-option
                    *ngFor="let value of shockDetectedDetectValues"
                    [value]="value"
                  >
                    {{ value }}g
                  </mat-option>
                </mat-select>
                @if (
                  formGroup
                    .get("shockDetectedDetectValue")!
                    .hasError("invalidSelection") ||
                  formGroup
                    .get("shockDetectedDetectValue")!
                    .hasError("required")
                ) {
                  <mat-error> 衝撃値を選択してください。 </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        }
      </div>

      <div class="tw-mt-2 tw-ml-8">
        @if (deviceType?.fmd) {
          <div
            class="tw-min-h-[45px] tw-mb-1 tw-w-full tw-flex tw-items-center tw-my-4"
          >
            <div
              class="tw-min-w-[208px] tw-w-52 tw-flex tw-items-center tw-my-4"
            >
              フライトモード<mat-icon
                [matTooltip]="
                  '航空輸送を使用する場合はONにすることでフライト中の通信をオフにすることができます。\n' +
                  'フライト中はセンサー値の取得が15分間隔になります。'
                "
                matTooltipClass="tw-whitespace-pre-line matp-medium-tooltip"
                class="tw-ml-1"
              >
                info
              </mat-icon>
            </div>
            <mat-slide-toggle
              color="primary"
              class="tw-min-w-[46px]"
              formControlName="fmd"
            ></mat-slide-toggle>
          </div>
        }
        @if (formGroup.controls["deviceTypeId"].value) {
          <div
            class="tw-min-h-[45px] tw-mb-1 tw-w-full tw-flex tw-items-center tw-my-4"
          >
            <div
              class="tw-min-w-[208px] tw-w-52 tw-flex tw-items-center tw-my-4"
            >
              配送設定での利用許可
              <mat-icon
                [matTooltip]="tooltipMessage"
                matTooltipClass="tw-whitespace-pre-line matp-medium-tooltip"
                class="tw-ml-1"
              >
                info
              </mat-icon>
            </div>
            <mat-slide-toggle
              color="primary"
              class="tw-min-w-[46px]"
              formControlName="shipmentTracking"
            ></mat-slide-toggle>
          </div>
        }
      </div>
    </mat-dialog-content>

    <mat-dialog-actions class="tw-flex !tw-justify-center !tw-px-6 tw-gap-x-4">
      <button
        id="btn-cancel-add-asset-type"
        mat-raised-button
        mat-dialog-close
        class="tw-w-40"
      >
        <mat-icon>close</mat-icon>
        キャンセル
      </button>
      <button
        id="btn-add-asset-type"
        mat-raised-button
        color="accent"
        class="tw-w-40"
        type="submit"
        [disabled]="formGroup.invalid || isDisabled"
      >
        <mat-icon>done</mat-icon>
        <span>{{ updating ? "変更" : "新規登録" }}</span>
      </button>
    </mat-dialog-actions>
  </form>
</div>
